import dayjs from "dayjs";
import { EntryLogTable } from "features/log/components/table/entry-log";
import { VehicleFilterFormValuesPaginated } from "features/log/components/Top-bar/type";
import { VehicleUpLoadingLogTopBar } from "features/log/components/Top-bar/vehicleuploading-top-bar";
import { useGetLogList } from "features/log/use-cases/get-getSuppliers";
import { MatrialFilterFormValuesPaginated } from "features/master/components/master-filter-form";
import { usePaginationParams } from "hooks";
import { omit } from "lodash";
import {  useState } from "react";
import { formatDate } from "utils/date";

export const LogVechileUpLoadingView = () => {
  const getInitialFilterValues: any = {
    date: [undefined, undefined],
    DriverName: undefined,
    SupplierName: undefined,
    VNumber: undefined,
  };
  const [userEditData, setUserEditData] = useState<any>(undefined);
  const [showAppUserModal, setShowAppUserModal] = useState(false);
  const { params, updateParams, resetPage } =
    usePaginationParams<VehicleFilterFormValuesPaginated>({
      page: 1,
      size: 10,
      ...getInitialFilterValues,
    });
  const preparePayload = (params1: MatrialFilterFormValuesPaginated) => {
    const createdAtFrom = params1.date?.[0];
    const createdAtTo = params1.date?.[1];

    return {
      ...omit(params1, ['date']),
      EntryTypeId:3,
      created_at_from: createdAtFrom
        ? formatDate({
          date: dayjs(createdAtFrom).startOf('day'),
          format: 'dbDate',
        })
        : undefined,
      created_at_to: createdAtTo
        ? formatDate({
          date: dayjs(createdAtTo).endOf('day'),
          format: 'dbDate',
        })
        : undefined,
    };
  };

  const getvehcListQueryResponse: any = useGetLogList(preparePayload(params as any), {
    retry: false,
  });

  const handleFiltersChange = (values: VehicleFilterFormValuesPaginated) => {
    updateParams(values);
    resetPage();
  };

  return (
    <>
      <VehicleUpLoadingLogTopBar
        getInitialFilterValues={getInitialFilterValues as any}
        handleFilter={handleFiltersChange}
        userEditData={userEditData}
        showAppUserModal={showAppUserModal}
        setShowAppUserModal={setShowAppUserModal}
         onRefresh={getvehcListQueryResponse.refetch}
      />
      <EntryLogTable
        isvehicleListLoading={
          getvehcListQueryResponse.isLoading &&
          getvehcListQueryResponse.isFetching
        }
        vehicleList={getvehcListQueryResponse?.data?.res?.items}
        itemsCount={getvehcListQueryResponse.data?.rc?.totalRecords || 0}
        tableParams={params as any}
        updateParams={updateParams}
        setUserEditData={setUserEditData}
        setShowAppUserModal={setShowAppUserModal}
        onRefresh={getvehcListQueryResponse.refetch}
        isFetching={ getvehcListQueryResponse.isFetching}

      />
    </>


  );
};
